import { useRef, useState, useEffect } from "react";
import useAuth from "../hooks/useAuth";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "./Login.css";
import axios from "../api/axios";
import { Container } from 'react-bootstrap';
import 'boxicons/css/boxicons.min.css';
const url = "/api/login";

const Login = () => {
  const { setAuth, persist, setPersist } = useAuth();

  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/dashboard";


  console.log(from);

  const userRef = useRef();
  const errRef = useRef();

  const [username, setUsername] = useState("");
  const [pwd, setPwd] = useState("");
  const [errMsg, setErrMsg] = useState("");

  useEffect(() => {
    userRef.current.focus();
  }, []);

  useEffect(() => {
    setErrMsg("");
  }, [username, pwd]);

  const handleSubmit = async (e) => {
    e.preventDefault();



    try {
      const payload = {
        username: username,
        password: pwd,
      };

      var accessToken = null;
      var roles = "";
      var name = "";
      var franchise_id = null;
      var franchise_name = null;
      var business_type = null;
      var parent_franchise_id = null;

      await axios
        .post(url, payload, {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        })
        .then((result) => {
          accessToken = result?.data?.accessToken;
          roles = result?.data?.role;
          name = result?.data?.name;
          franchise_id = result?.data?.franchise_id;
          franchise_name = result?.data?.franchise_name;
          business_type = result?.data?.business_type;
          parent_franchise_id = result?.data?.parent_franchise_id;
          // console.log(`accessToken :${result?.data?.accessToken}`);

        });



      setAuth({ username, roles, name, franchise_id, accessToken, franchise_name, business_type, parent_franchise_id });
      setUsername("");
      setPwd("");
      navigate(from, { replace: true });
    } catch (err) {
      if (!err?.response) {
        setErrMsg("No Server Response");
      } else if (err.response?.data) {
        setErrMsg(err.response.data.message);
      } else {
        setErrMsg("Login Failed!");
      }
      errRef.current.focus();
    }
  };

  const togglePersist = () => {
    setPersist((prev) => !prev);
  };

  useEffect(() => {
    localStorage.setItem("persist", persist);
  }, [persist]);

  return (
    <>
      {/* <section className="loginsec">
        <p
          ref={errRef}
          className={errMsg ? "errmsg" : "offscreen"}
          aria-live="assertive"
        >
          {errMsg}
        </p>
        <h3>Sign In</h3>

        <form onSubmit={handleSubmit}>
          <label htmlFor="username">Username:</label>
          <input
            type="text"
            id="username"
            ref={userRef}
            autoComplete="off"
            onChange={(e) => setUsername(e.target.value)}
            value={username}
            required
          />

          <label htmlFor="password">Password:</label>
          <input
            type="password"
            id="password"
            autoComplete="off"
            onChange={(e) => setPwd(e.target.value)}
            value={pwd}
            required
          />
          <button>Sign In</button>


          <div className="persistCheck">
            <input
              type="checkbox"
              id="persist"
              onChange={togglePersist}
              checked={persist}
            />
            <label htmlFor="persist">Trust This Device</label>
          </div>
        </form>
        <p>
          Need an Account?
          <br />
          <span className="line">
            <Link to="/register">Sign Up</Link>
          </span>
        </p>
      </section> */}

      <Container>
        <section className="loginbody">
          <p
            ref={errRef}
            className={errMsg ? "errmsg" : "offscreen"}
            aria-live="assertive"
          >
            {errMsg}
          </p>

          <div className="wrapper">
            <form onSubmit={handleSubmit}> {/* Add onSubmit handler to trigger login */}

              {/* <h1>LOGIN</h1> */}
              <div className="center-image">

                <img src="/images/newlogo.png" width="80%" className='log-img' />
              </div>

              <div className="input-box">

                <input
                  type="text"
                  id="username"
                  placeholder="Username"
                  autoComplete="off"
                  ref={userRef} // Attach the ref to this input

                  onChange={(e) => setUsername(e.target.value)}
                  value={username}
                  required
                />
                <i className="bx bxs-user icon"></i>
              </div>


              <div className="input-box">

                <input
                  type="password"
                  id="password"
                  autoComplete="off"
                  placeholder="Password"

                  onChange={(e) => setPwd(e.target.value)}
                  value={pwd}
                  required
                />
                <i className="bx bxs-lock-alt"></i>
              </div>

              <button type="submit" className="btn">Sign In</button>



              <div className="persistCheck remember-forget">
                <label>
                  <input type="checkbox"
                    id="persist"
                    onChange={togglePersist}
                    checked={persist}
                  />
                  <span className="newspan">Trust This Device</span>
                </label>
                {/* <a href="#">Forgot password?</a> */}
              </div>



              {/* <div className="register-link">
      <p>
      Need an Account? <br />
      <span className="line">
            <Link to="/register">Sign Up</Link>
          </span>
      </p>
    </div> */}

            </form>
          </div>
        </section>
      </Container>

    </>
  );
};

export default Login;
